export default {
  title: 'Registros del sistema',
  source: 'Conectado a la instancia: {{instanceId}} · Archivo: {{fileName}}',
  instances: 'Instancias',
  localInstance: '{{instanceId}} (conectada)',
  instanceLost: 'Esta instancia dejó de enviar su registro (apagada o inaccesible)',
  status: {
    connecting: 'Conectando...',
    connected: 'En vivo',
    disconnected: 'Desconectado',
  },
  searchPlaceholder: 'Filtrar líneas...',
  levels: {
    error: 'Error',
    warn: 'Advertencia',
    info: 'Info',
    debug: 'Depuración',
  },
  httpRequests: 'Solicitudes HTTP',
  httpRequestsTitle: 'Mostrar u ocultar las líneas que registran las solicitudes HTTP atendidas por el servidor',
  maxLines: 'Máx. líneas',
  pause: 'Pausar',
  resume: 'Reanudar ({{count}} nuevas)',
  export: 'Exportar',
  exportTitle: 'Descargar todas las líneas cargadas (sin aplicar los filtros) en un archivo de texto',
  clear: 'Limpiar',
  reconnect: 'Reconectar',
  jumpToLatest: 'Ir a las más recientes',
  fileNotFound: 'Instancia {{instanceId}}: archivo de registro {{fileName}} no encontrado, esperando a que se cree',
  linesCount: 'Mostrando {{visible}} de {{total}} líneas',
  markers: {
    rotated: 'archivo de registro rotado',
    skipped: 'demasiadas líneas escritas: se omitieron algunas líneas',
    truncated: 'líneas anteriores no cargadas',
  },
}
